import { post } from '@/api/core'

import { GroupMemberJoinReq } from './types'

export type { GroupMemberJoinReq } from './types'

/**
 * 申请加入群
 * @description https://api.yinnho.cn/api.php?do=group_member_join&help
 *
 * @param data 请求参数
 */
export function group_member_join (data: GroupMemberJoinReq) {
  return post('group_member_join', data)
}
